module.exports = __webpack_public_path__ + "img/afp_push_ups.ea9b866d.jpg";